(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("UiKit"));
	else if(typeof define === 'function' && define.amd)
		define(["UiKit"], factory);
	else if(typeof exports === 'object')
		exports["adminFrame"] = factory(require("UiKit"));
	else
		root["adminFrame"] = factory(root["UiKit"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition